define('AwaLabs.MultipleAddToCartPLP', [
    'MultipleAddToCartPLP.Cell.View',
    'MultipleAddToCartPLP.View',
    'MultipleAddToCart.Backbone.History',
    'Tracker'
], function AwaLabsMultipleAddToCartPLP(
    MultipleAddToCartPLPCellView,
    MultipleAddToCartPLPView,
    MultipleAddToCartBackboneHistory,
    Tracker
) {

    // Override original trackAddToCart
    // Avoid issues with line undefined because a bug on the reference with latest_addition
    // when adding more than one item to the cart, this return lines ids separated by comma and get('lines').get return undefined
    // LiveOrder.Model.ts - line 211
    Tracker.prototype.trackAddToCart = function(line) {
        if(line){
            return this.track('trackEvent', {
                category: 'Shopping - User Interaction',
                action: 'Add To Cart',
                label: line.generateURL()
            }).track('trackAddToCart', line);
        }
    };

    return {
        mountToApp: function mountToApp(application) {
            var plp = application.getComponent('PLP');
            var multipleAddToCartMainView;

            if (plp) {
                MultipleAddToCartBackboneHistory.mountToApp(application);

                multipleAddToCartMainView = new MultipleAddToCartPLPView({
                    application: application
                });

                plp.addChildView('Facets.Items', function FacetsItems() {
                    return multipleAddToCartMainView;
                });

                plp.addChildView('Cart.QuickAddToCart', function CartQuickAddToCart() {
                    return new MultipleAddToCartPLPCellView({
                        multipleAddToCartMainView: multipleAddToCartMainView,
                        application: application
                    });
                });
            }
        }
    };
});
